<template>
    <div class="payment-slip-page">
      <h2>繳費單資訊</h2>
  
      <!-- 錯誤訊息 -->
      <div v-if="errorMsg" class="error-message">
        {{ errorMsg }}
      </div>
  
      <!-- 如果正在載入 -->
      <div v-else-if="loading">
        <p>資料載入中...</p>
      </div>
  
      <!-- 顯示繳費資訊 + 訂單明細 -->
      <div v-else>
        <!-- {{orderData}} -->
        <!-- 繳費資訊(ATM/超商/貨到付款) -->
        <section v-if="orderData" class="payment-info-section">
          <p class="mer-trade-no">
            <strong>訂單編號：</strong>
            {{ orderData.order_id }}
          </p>
          <p class="trade-amt">
            <strong>付款金額：</strong>
            <span class="highlight-amt">NT ${{ orderData.total_amount }}</span>
          </p>
          <p>
            <strong>付款狀態：</strong>
            <span :style="{ color: orderData.payment_status_color }">{{ orderData.payment_status_label }}</span>
          </p>
          <p>
            <strong>繳費方式：</strong>
            <span >{{ orderData.paymentname }}</span>
          </p>

          <!-- 信用卡 -->
            <div v-if="orderData.payment === 'credit'">
            <p>
              <strong>信用卡號：</strong>
              <span class="credit-card">{{ orderData.payment_code }}</span>
            </p>
          </div>
  
          <!-- ATM -->
          <div v-if="orderData.payment === 'atm'" class="atm-info">
            <p>
              <strong>銀行代號：</strong>
              <span class="bank-code">{{ orderData.bankCode }}</span>
            </p>
            <p>
              <strong>虛擬帳號：</strong>
              <span class="v-account">{{ orderData.vAccount }}</span>
              <button class="copy-button" @click="copyToClipboard(orderData.vAccount)">複製</button>
            </p>
            <p>
              <strong>繳費到期日：</strong>
              {{ orderData.expiredate }}
            </p>
            <p v-if="orderData.payment_status">
              <strong>付款狀態：</strong>
              {{ orderData.expiredate }}
            </p>
          </div>
  
          <!-- 超商代碼 -->
          <div v-else-if="orderData.payment === 'cvs'" class="cvs-info">
            <p>
              <strong>繳費代碼：</strong>
              <span class="cvs-code">{{ orderData.payment_code }}</span>
              <button class="copy-button" @click="copyToClipboard(orderData.payment_code)">複製</button>
            </p>
            <p>
              <strong>繳費到期日：</strong>
              {{ orderData.expiredate }}
            </p>
          </div>
  
          <!-- 貨到付款 -->
          <div v-else-if="orderData.payment === 'cod'">
            <p>貨到付款，不需事先繳費。</p>
          </div>
          
        </section>
  
        <!-- 訂單資料 -->
        <section v-if="orderData && orderData.order_id" class="order-info-section">
          <h3>訂單資訊</h3>
          <p>
            <strong>訂購人：</strong>
            {{ orderData.buy_name }} / {{ orderData.buy_phone }}
          </p>
          <p>
            <strong>收件人：</strong>
            {{ orderData.name }} / {{ orderData.phone }}
          </p>
          <p>
            <strong>運送方式：</strong>
                <img v-if ="orderData.shippingicon_url" :src="orderData.shippingicon_url" width="20px" height="20px" alt="shipping icon" />
                {{ orderData.shippingname }}
            </p>
          <p>
            <strong>收件地址：</strong>
            <span>
              {{ orderData.zip ? `(${orderData.zip})` : "" }}
              {{ orderData.city ? `${orderData.city}` : "" }}
              {{ orderData.district ? `${orderData.district}` : "" }}
              {{ orderData.street ? `${orderData.street}` : "" }}
              {{ orderData.store_id ? `(${orderData.store_id})` : "" }}
              {{ orderData.store_name ? `[${orderData.store_name}]` : "" }}
              {{ orderData.store_addr ? `${orderData.store_addr}` : "" }}
            </span>
          </p>
          <p>
            <template v-if="orderData.invoice_type === 'personal'">
              <strong>個人發票：</strong>
              <template v-if="orderData.carrier_type === '3J0002'">
                手機條碼 {{ orderData.mobile_barcode }}
              </template>
              <template v-else-if="orderData.carrier_type === 'CQ0001'">
                自然人憑證 {{ orderData.citizen_barcode }}
              </template>
              <template v-else-if="orderData.carrier_type === 'amego'">
                會員載具 {{ orderData.buy_email }}
              </template>
            </template>
            <template v-else-if="orderData.invoice_type === 'Company'">
              <strong>公司發票：</strong>{{ orderData.company_name }} - {{ orderData.tax_id }}
            </template>
            <template v-else-if="orderData.invoice_type === 'Donate'">

             <strong>發票捐贈</strong>
            </template>
          </p>
  
          <!-- 訂單明細 (若有) -->
          <div v-if="orderItems && orderItems.length" class="order-item-section">
            <h4>訂單明細</h4>
            <div class="table-responsive">
              <table class="order-detail-table">
                <thead>
                  <tr>
                    <th>商品名稱</th>
                    <th>規格</th>
                    <th>數量</th>
                    <th>單價</th>
                    <th>小計</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in orderItems" :key="idx">
                    <td data-label="名稱" class="td-product">
                      <img
                        v-if="item.image_url"
                        :src="item.image_url"
                        class="product-img"
                        alt="product image"
                      />
                      {{ item.title }}
                    </td>
                    <td data-label="規格" class="td-variant">
                      {{ item.variant_name || '無規格' }}
                    </td>
                    <td data-label="數量" class="td-quantity">
                      {{ item.quantity }}
                    </td>
                    <td data-label="單價" class="td-price">
                      NT$ {{ item.price }}
                    </td>
                    <td data-label="小計" class="td-subtotal">
                      NT$ {{ item.price * item.quantity }}
                    </td>
                  </tr>
                  <tr v-for="(g, idx) in orderGifts" :key="'gift_'+idx" class="tr-gift">
                    <td data-label="名稱" class="td-product">🎁 {{ g.gift_name }}（贈品）</td>
                    <td data-label="規格">-</td>
                    <td data-label="數量">{{ g.gift_quantity }}</td>
                    <td data-label="單價">NT$ 0</td>
                    <td data-label="小計">NT$ 0</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="order-summary-rows">
              <div v-if="orderData.shipping_fee > 0" class="summary-row">
                <span>運費：</span><span>NT$ {{ orderData.shipping_fee }}</span>
              </div>
              <div v-if="couponDiscount > 0" class="summary-row summary-row--discount">
                <span>折扣券：</span><span>－ NT$ {{ couponDiscount }}</span>
              </div>
              <div class="summary-row summary-row--total">
                <strong>券後實付金額：</strong><strong>NT$ {{ orderData.total_amount }}</strong>
              </div>
            </div>
          </div>
        </section>
  
        <!-- 若都沒拿到資料 -->
        <div v-else>
          <p>尚未取得繳費資料或訂單資訊</p>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import {  ref, computed, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute, useRouter } from 'vue-router'
  import axios from 'axios'
  import { pixelPurchase } from '@/plugins/metaPixel'

  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  
  const loading = ref(false)
  const errorMsg = ref('')

  // 從後端拿到的「訂單主要資訊」
  const orderData = ref(null)
  const orderItems = ref([])
  const orderGifts = ref([])

  const couponDiscount = computed(() => {
    if (!orderData.value) return 0
    return Number(orderData.value.discount_total) || 0
  })
  // 繳費資訊 (例如 BankType, PayNo, PaymentType, ExpireDate...)
  const slipData = ref(null)

  function copyToClipboard(text) {
  // 若支援 clipboard API
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    navigator.clipboard.writeText(text).catch(err => console.error('複製失敗：', err))
  } else {
    // 不支援時 fallback
    const input = document.createElement('input')
    input.value = text
    document.body.appendChild(input)
    input.select()
    try {
      document.execCommand('copy')
    } catch (err) {
      console.error('複製失敗：', err)
    }
    document.body.removeChild(input)
  }
}

  onMounted(async () => {
    try {
      loading.value = true
  
      // 1) 取得路由 query 的繳費參數
      //   e.g. ?MerTradeNo=100176&TradeAmt=100&BankType=013&PayNo=xxx&PaymentType=2&ExpireDate=xxx
      const MerTradeNo = route.query.MerTradeNo
      if (!MerTradeNo) {
        errorMsg.value = "無法取得 MerTradeNo，請確認 URL 是否正確"
        return
      }
      // 先存繳費資訊 slipData
      slipData.value = {
        MerTradeNo: route.query.MerTradeNo,
        // TradeAmt: route.query.TradeAmt,
        // BankType: route.query.BankType,
        // PayNo: route.query.PayNo,
        // PaymentType: route.query.PaymentType,
        // ExpireDate: route.query.ExpireDate,
        // Store: route.query.Store // 若有
      }
      // 2) 呼叫後端，取得「該訂單 + 訂單明細」
      //    例如: GET /api/order/getOrderAndDetails/:merTradeNo
      const res = await axios.get(`/api/order/getOrderAndDetails/${MerTradeNo}`)
      if (res.data.success) {
        const orderOwnerId = res.data.order.user_id
        const currentUserId = store.state.userProfile.user_id
        const isLoggedIn = store.state.isLoggedIn
        if(!isLoggedIn) {
          router.push('/login')
          return
        }
        console.log('store.state.userProfile', store.state.userProfile)
        if (orderOwnerId !== currentUserId) {
          router.push('/login')
          return
        }
        // 後端回傳 { success:true, order, orderItems }
        if(res.data.order.payment === 'atm') {
          res.data.order.bankCode = res.data.order.payment_code.split('-')[0]
          res.data.order.vAccount = res.data.order.payment_code.split('-')[1]
        }
        if(res.data.order.payment === 'linepay') {
          store.dispatch('clearAllCart')
          res.data.order
        }
        orderData.value = res.data.order
        // 後端 getOrderDetails 會把贈品(is_gift)混進商品清單；這頁另外用 orderGifts 顯示贈品，故排除避免重複
        orderItems.value = (res.data.orderItems || []).filter(it => !it.is_gift)
        orderGifts.value = res.data.orderGifts || []
        // Meta Pixel：完成購買事件（訂單成立成功後，每筆訂單只計一次）
        pixelPurchase({
          orderId: res.data.order.order_id,
          value: res.data.order.total_amount
        })
      } else {
        errorMsg.value = res.data.message || '後端回傳錯誤'
      }
    } catch (err) {
      console.error(err)
      errorMsg.value = err.response?.data?.message || err.message
    } finally {
      loading.value = false
    }
  })
  </script>
  
  <style scoped>
  .payment-slip-page {
    max-width: 800px;
    margin: 0 auto;
    background: #fff;
    padding: 20px;
    border-radius: 4px;
  }
  
  /* 標題 */
  .payment-slip-page h2 {
    font-size: 1.8rem;
    margin-bottom: 16px;
    color: #333;
    text-align: center;
    border-bottom: 2px solid #ccc;
    padding-bottom: 8px;
  }
  
  /* 區塊分區 */
  .payment-info-section,
  .order-info-section {
    margin-bottom: 24px;
    border: 1px solid #ccc;
    padding: 16px;
    border-radius: 6px;
    background-color: #fafafa;
  }
  
  .payment-info-section p,
  .order-info-section p {
    line-height: 1.5;
    margin: 6px 0;
  }
  
  /* 金額加粗 */
  .highlight-amt {
    color: #d9534f;
    font-weight: bold;
    font-size: 1.2rem;
  }
  
  /* ATM / 超商訊息 */
  .atm-info p,
  .cvs-info p {
    margin: 8px 0;
  }
  
  /* 訂單資訊 */
  .order-info-section h3 {
    margin-top: 0;
    margin-bottom: 12px;
    border-bottom: 2px solid #999;
    padding-bottom: 4px;
  }
  
  .order-item-section {
    margin-top: 16px;
  }
  
  .order-item-section h4 {
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 1.2rem;
    border-bottom: 1px solid #ccc;
    padding-bottom: 4px;
  }
  
  /* 表格容器: 手機可左右捲動 */
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* iOS慣性 */
  }
  
  .order-detail-table th,
  .order-detail-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
  }
  .order-detail-table thead {
    background: #f0f0f0;
  }
  .order-detail-table th {
    font-weight: bold;
  }
  
  /* 商品圖 */
  .product-img {
    width: 40px;
    height: auto;
    margin-right: 8px;
    vertical-align: middle;
  }
  
  /* 錯誤訊息 */
  .error-message {
    color: red;
    margin-bottom: 16px;
    font-weight: bold;
    text-align: center;
  }
  
  /* 手機響應 - 使表格垂直展開 */
  @media (max-width: 768px) {
    .payment-slip-page {
      padding: 16px;
    }
    .payment-info-section,
    .order-info-section {
      padding: 12px;
    }
    .highlight-amt {
      font-size: 1.1rem;
    }
    .product-img {
      width: 35px;
    }
  
    /* 關鍵：讓每個 <td> block 化 + 用 data-label 顯示標題 */
    .order-detail-table thead {
      display: none; /* 隱藏表頭 */
    }
    .order-detail-table,
    .order-detail-table tbody,
    .order-detail-table tr,
    .order-detail-table td {
      display: block;
      width: 100%;
    }
    .order-detail-table tr {
      margin-bottom: 1rem;
      border-bottom: 2px solid #ddd;
    }
    .order-detail-table td {
      border: none;
      position: relative;
      padding-left: 20%;
      text-align: left;
      white-space: normal;
      border-bottom: 1px dashed #ccc;
    }
    .order-detail-table td:before {
      content: attr(data-label);
      position: absolute;
      left: 10px;
      width: 45%;
      white-space: nowrap;
      font-weight: bold;
    }
    /* 最後一列的 border 調整 */
    .order-detail-table tr:last-of-type td {
      border-bottom: 0;
    }
  }

  .order-summary-rows {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}
.summary-row {
  display: flex;
  gap: 8px;
  font-size: 0.95rem;
}
.summary-row--discount {
  color: #e74c3c;
}
.summary-row--total {
  font-size: 1.05rem;
  border-top: 1px solid #ccc;
  padding-top: 4px;
  margin-top: 2px;
}

.copy-button {
  cursor: pointer;
  font-size: 0.8rem;
  padding: 3px 6px;
  margin-left: 12px;
}
.tr-gift td {
  color: #27ae60;
  background: #f6fff8;
}
  </style>
  